export default {
    label_task:{
        en:"Analysis Years",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Analysis Year",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Analysis Year",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Analysis Year",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}